/* Start updated by Pooja Vaishnav and it will create new pricebook and update it also for the related product*/
import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import PubSub from 'pubsub-js';
import "react-bootstrap-typeahead/css/Typeahead.css";
import SparkApi from "../api/SparkApi";
import moment from "moment";

const PricebookEdit = (props) => {
  const navigate = useNavigate();
  const [pricebook, setPricebook] = useState({});
  const [active, setActive] = useState(false);
  const [validated, setValidated] = useState(false);

  useEffect(() => {
    if (props?.pricebooks?.id) {
      setPricebook(props?.pricebooks);
      setActive(props?.pricebooks.active);
    } else {
      setPricebook({});
      let current = new Date();
      pricebook.productid = props.parent.id;
      setPricebook({ ...pricebook, productid: props.parent.id, createddate: moment(current).format("YYYY-MM-DD") });
    }
  }, pricebook);

  const checkRequredFields = () => {
    if (
      pricebook.amount &&
      pricebook.amount.trim() !== "" 
    ) {
      return false;
    }
    return true;
  };
  const handleChange = (e) => {
    setPricebook({ ...pricebook, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (checkRequredFields()) {
      setValidated(true);
      return;
    }
    pricebook.active = active;
    if (props?.pricebooks?.id) {
      const result = await SparkApi.savePricebook(pricebook);
      if (result.errors) {
        PubSub.publish('RECORD_ERROR_TOAST', { title: 'Record Save Error', message: result.errors });
      }else{
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record updated successfully' });
      }
      submitPricebooks();
    } else {
      const result = await SparkApi.createPricebook(pricebook);
      if (result.errors) {
        PubSub.publish('RECORD_ERROR_TOAST', { title: 'Record Save Error', message: result.errors });
      }else{
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record created successfully' });
      }
      submitPricebooks();
    }
  };

  const submitPricebooks = () => {
    props.submitPricebooks();
  };

  return (
    <Modal {...props} aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton className="view-form-header">
        <Modal.Title id="contained-modal-title-vcenter">
          Pricebook
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container className="view-form ">
          <Row>
            <Col lg={12}>
              <Form
                className="mt-3"
                onSubmit={handleSubmit}
                controlId="taskCreate"
              >
                <Row>
                  <Col lg={6}>
                    <Form.Group className="mx-3" controlId="formBasicLastName">
                      <Form.Label className="form-view-label">
                        Amount
                      </Form.Label>
                      <Form.Control
                        required
                        type="number"
                        name="amount"
                        placeholder="Enter amount"
                        value={pricebook.amount}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        GST
                      </Form.Label>
                      <Form.Control
                        required
                        type="number"
                        name="gst"
                        placeholder="Enter Gst"
                        value={pricebook.gst}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col lg={4}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        Active
                      </Form.Label>

                      <Form.Check
                        defaultChecked={pricebook.active}
                        value={active}
                        onClick={(e) => {
                          e.target.checked ? setActive(true) : setActive(false);
                        }}
                      ></Form.Check>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleSubmit}>
          Save
        </Button>
        <Button onClick={props.onHide} variant="light">
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default PricebookEdit;
/* End updated by Pooja Vaishnav */